import{_ as o}from"./_baseGetTag-852b3600.js";import{i as t}from"./isObjectLike-964c2f40.js";var e=function(e){return"symbol"==typeof e||t(e)&&"[object Symbol]"==o(e)};export{e as i};
//# sourceMappingURL=isSymbol-36126c23.js.map
